import angular from 'angular';
import zxcvbn from 'zxcvbn';

import '../../core/main/directive/match/directive'
import './style.scss';

document.write(require('./view.html').default);

angular.module("merchant.application.page.resetConfirm", [
]).controller("merchant.application.page.resetConfirm.controller", [
    "$scope", "$controller", "$location",
    "merchant.application.main.factory.authentication",
    function($scope, $controller, $location, Authentication) {
        $controller("merchant.application.page.controller", {$scope: $scope});

        var token = $location.search().t;
        if (! token) {
            $location.path("reset-ask");
        }

        $scope.model.reset = {
            hasReset: false,
            invalid: false,
            fatalError: false,
            minimumPasswordStrength: 2 // zero based numbering, so 2 is actually '3' for humans
        };

        $scope.model.reset.passwordStrength = undefined;

        if (token) {
            Authentication.saveResetValidateToken(token, function(outcome) {
                if (! outcome || outcome.status !== "success") {
                    $location.path("reset-ask").search({expired: 1});
                }
            }, function() {
                $scope.model.reset.fatalError = true;
            });
        }

        $scope.submit = function() {
            if ($scope.form.$valid && $scope.passwordStrength() >= $scope.model.reset.minimumPasswordStrength) {
                $scope.resetPassword();
            }
        };

        $scope.resetPassword = function() {
            var parameters = {
                token: token,
                password: $scope.model.reset.password,
                confirmPassword: $scope.model.reset.confirmPassword
            };
            $scope.model.reset.invalid = false;
            Authentication.saveReset(parameters, function(outcome) {
                if (outcome.status === "success") {
                    $scope.model.reset.hasReset = true;
                } else {
                    $scope.model.reset.invalid = true;
                }
            }, function() {
                $scope.model.reset.fatalError = true;
            });
        };

        $scope.passwordStrength = function() {
            // if we have a password then set the password strength
            // or if we don't have a password set the strength to the minimum
            // but only if the user has put data into the password input
            var password = $scope.model.reset.password;
            if (password && typeof zxcvbn !== "undefined") {
                $scope.model.reset.passwordStrength = zxcvbn(password).score;
            } else {
                if ($scope.form.password.$dirty) {
                    // if the user has started typing their password
                    // make sure the password indicator has the minimum strength to show
                    $scope.model.reset.passwordStrength = 0;
                }
            }
            return $scope.model.reset.passwordStrength;
        };

    }
]);
